import { useState } from "react"

import { Alert } from "@/components/ui/alert"
import { Button } from "@/components/ui/button"

export function AlertPreviewRoute(): JSX.Element {
  const [visible, setVisible] = useState(true)

  return (
    <div className="mx-auto max-w-4xl px-8.5 py-11">
      <header className="mb-8">
        <div className="font-id text-eyebrow uppercase tracking-[0.16em] text-text-3">
          Primitive
        </div>
        <h1 className="mt-1 text-display text-text">Alert</h1>
      </header>

      <Section title="Info">
        <div className="w-full">
          <Alert tone="info" title="Registry lookup is slow today">
            Reviews can still be run — pipeline falls back to the uploaded master.
          </Alert>
        </div>
      </Section>

      <Section title="Warning">
        <div className="w-full">
          <Alert tone="warning" title="Printed label date is missing">
            Enter the stamp date so the correct master governs.
          </Alert>
        </div>
      </Section>

      <Section title="Error">
        <div className="w-full">
          <Alert tone="error" title="Master upload failed">
            The file couldn&rsquo;t be parsed. Try re-exporting as PDF.
          </Alert>
        </div>
      </Section>

      <Section title="Success">
        <div className="w-full">
          <Alert tone="success" title="Report sent to client">
            The client will see it in their inbox within the next few minutes.
          </Alert>
        </div>
      </Section>

      <Section title="Dismissable">
        <div className="w-full">
          {visible ? (
            <Alert
              tone="info"
              title="Dismissable alert"
              action={
                <Button size="sm" onClick={() => setVisible(false)}>
                  Dismiss
                </Button>
              }
            >
              Click dismiss to hide this alert.
            </Alert>
          ) : (
            <Button size="sm" onClick={() => setVisible(true)}>
              Show alert again
            </Button>
          )}
        </div>
      </Section>
    </div>
  )
}

function Section({ title, children }: { title: string; children: React.ReactNode }): JSX.Element {
  return (
    <section className="mb-8">
      <h2 className="mb-3.5 font-id text-caption uppercase tracking-[0.16em] text-text-3">
        {title}
      </h2>
      <div className="flex flex-wrap items-center gap-3.5">{children}</div>
    </section>
  )
}
